<div class="venue-button-part">
	<button class='btn {{buttonClass()}}' [ngClass]='{"btn-danger": !venue}' style='margin-right:0.8em;'
		(click)='showDialog()'>
		<common-icon-text [iconStyle]="icon.iconStyle" [icon]="icon.iconClass" [text]="icon.text"></common-icon-text>
	</button>
</div>